import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getData } from "../../../../lib/commonFunctions";
import SubMenu from "../../../Menu/SubMenu";
import { GovernyInfo } from "../../../../lib/types";
import { portraits } from "../../../../assets/images/races";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";
import { DragescentState } from "../../../../store/reducers/stateType";

type OverviewRowData = {
  technologyPoints: number;
  investedPoints: number;
  unlockDevelopments: number[];
}

const DevelopmentOverview = () => {
  const emperor = useSelector((state: DragescentState) => state.governorate.alliance.emperor);
  const members = useSelector((state: DragescentState) => state.governorate.alliance.members);

  const [data, setData] = useState<{[keys: string]: OverviewRowData} | null>(null);

  useEffect(() => {
    getData(`/api/overview/development`)
      .then(overviewData => setData(overviewData));
  }, []);


  return (
    <>
      <SubMenu
        tabs={[
          {
            name: "AllianceOverview",
            title: "Overview",
            icon: "imperator",
            label: "Alliance",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "GeneralsOverview",
            title: "Overview",
            icon: "imperator",
            label: "Generals",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "DevelopmentOverview",
            title: "Overview",
            icon: "imperator",
            label: "Development",
            active: true,
            parameters: {
              reload: false
            }
          },
          {
            name: "OverviewPalace",
            title: "Overview",
            icon: "imperator",
            label: "Overview Palace",
            active: false,
            parameters: {
              reload: true
            }
          }
        ]}
      />

      <div className="box imp-overview" style={{ overflowX: "scroll" }}>
        {data && <table className={"table text-center table-hover"}>
          <thead>
          <tr>
            <th style={{ width: "14%", textAlign: "left" }}>Governorate</th>
            <th style={{ width: "8%" }}>Unlocked developments</th>
            <th style={{ width: "10%" }}>Free points</th>
            <th style={{ width: "10%" }}>Points earned</th>
          </tr>
          </thead>
          <tbody>
          {members.map((member: GovernyInfo) => (
            <tr>
              <td className="no-padding-left text-left">
                <span>
                  <img width={37} height={37} src={portraits[member.race.name]} alt={"Race portrait"}/>
                </span>
                <span style={{ display: "inline-table", verticalAlign: "super" }}>
                    <GovernorateInfoLink
                      govId={member.id}
                      name={member.name}
                      raceName={member.race.name}
                    /><br/>
                  {member.commander && <i className={`icon icon-vojevudce icon-xs ${member.race.name}`}/>}
                  {emperor.id === member.id && <i className={`icon icon-imperator icon-xs ${member.race.name}`}/>}
                </span>
              </td>
              <td>
                {data[member.id].unlockDevelopments.join(", ")}
              </td>
              <td>
                {data[member.id].technologyPoints}
              </td>
              <td>
                {data[member.id].investedPoints + data[member.id].technologyPoints}
              </td>
            </tr>))
          }
          </tbody>
        </table>}
      </div>
    </>
  );
}

export default DevelopmentOverview;
